import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import VideoSection from "@/components/landing/VideoSection";
import Chapters from "@/components/landing/Chapters";
import Packs from "@/components/landing/Packs";
import Quiz from "@/components/landing/Quiz";
import Testimonials from "@/components/landing/Testimonials";
import Faq from "@/components/landing/Faq";
import PromoBanner from "@/components/landing/PromoBanner";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <>
      <Nav />
      <main>
        <PromoBanner />
        <Hero />
        <Marquee />
        <VideoSection />
        <Chapters />
        <Packs />
        <Quiz />
        <Testimonials />
        <Faq />
      </main>
      <Footer />
    </>
  );
}
